import LocationImportApprovalContainer from './LocationImportApprovalContainer';

export default LocationImportApprovalContainer;
